import {EChannelType, EContentType} from 'src/constants';
import {EMenuId} from 'src/containers/Layout';

import {ETemplateButtonOtpType} from '../MessageMatchers/WhatsAppForm/definitions';
import {EMessageMatcherButtonTypes} from '../MessageMatchers/definitions';
import {EMenuButtonAction} from './Item/types';
import {EFlowErrorCodes} from './api';
import {EFlowStatus, EFlowStepType, EUIActionType, EUIConditionType, EUIStepError} from './types';

export default {
  createTrigger: 'сценарий',
  empty: {
    title: 'Здесь пока пусто',
  },
  status: {
    [EFlowStatus.DRAFT]: 'Черновик',
    [EFlowStatus.ACTIVE]: 'Активен',
    [EFlowStatus.INACTIVE]: 'Остановлен',
    [EFlowStatus.SCHEDULED]: 'Запланирован',
    [EFlowStatus.FINISHED]: 'Завершен',
  },
  type: {
    [EFlowStepType.TRIGGER]: 'Стартовый блок',
    [EFlowStepType.CONDITION]: 'Условие',
    [EFlowStepType.ACTION]: 'Действие',
  },
  changeCondition: 'Изменить условие',
  blockSettings: 'Настройки блока',
  transitions: 'Переходов: {{count}}',
  description: {
    [EFlowStepType.TRIGGER]: 'Условие, с которого начнется ваш сценарий',
    [EFlowStepType.CONDITION]: 'Выберите условие',
    [EFlowStepType.ACTION]: 'Выберите действие',
    [EUIActionType.CC_DIALOG_SWITCH_ACTION]:
      'Диалог с получателем будет переведен в edna Chat Center',
    [EUIActionType.JIVO_DIALOG_SWITCH_ACTION]: 'Диалог с получателем будет переведен в Jivo',
    [EUIActionType.CALLBACK_DIALOG_SWITCH_ACTION]:
      'Сценарий передаст данные диалога с получателем во внешнюю систему по настроенному вебхуку для входящих сообщений',
    [EUIActionType.PAUSE_ACTION]: 'Во время паузы сценарий не отправляет сообщения получателю',
    [EUIActionType.ADD_SUBSCRIBER_TAG_ACTION]: 'Всем получателям будут присвоены указанные теги',
    [EUIActionType.DELETE_SUBSCRIBER_TAG_ACTION]: 'Всем получателям будут удалены указанные теги',
    [EUIConditionType.TAG_PRESENCE_CONDITION]: 'Выбрать получателей на основе тегов',
    [EUIConditionType.BUTTON_PRESSED]: 'Выбрать получателей, которые нажали кнопки в сообщении',
    [EUIConditionType.MESSAGE_RECEIVED]:
      'Выбрать получателей, которые направили входящее сообщение',
    [EUIConditionType.EXTERNAL_TRIGGER]: 'Получатели, для которых будет запущен внешний триггер',
  },
  title: {
    [EUIActionType.PAUSE_ACTION]: 'Сценарий ожидает ответ получателя в течение:',
  },
  trigger: {
    [EUIConditionType.MESSAGE_RECEIVED]: {
      title: 'Получено входящее сообщение',
      subtitle: 'Получатель ответил на сообщение',
    },
    [EUIConditionType.EXTERNAL_TRIGGER]: {
      title: 'Внешний триггер',
      subtitle: 'Получатели, для которых будет запущен внешний триггер',
    },
    [EUIConditionType.ANSWER_TIMEOUT_CONDITION]: {
      title: 'на выполнение любого из этих условий',
    },
    [EUIConditionType.BUTTON_PRESSED]: {
      title: {
        [EMessageMatcherButtonTypes.CHAT]: 'Нажатие кнопки в сообщении',
        [EMessageMatcherButtonTypes.TEXT]: 'Нажатие кнопки-текста',
        [EMessageMatcherButtonTypes.CALLBACK]: 'Нажатие кнопки-ответа',
        [EMessageMatcherButtonTypes.LOCATION]: 'Переход по кнопке-запросу локации',
        [EMessageMatcherButtonTypes.CONTACT]: 'Переход по кнопке-запросу контакта',
      },
      buttonLabel: 'Название кнопки',
      buttonId: 'Код кнопки',
      emptySubtitle: 'Значения кнопок не настроены',
    },
    [EUIConditionType.TAG_ASSIGN_TIMEOUT_CONDITION]: {
      title: 'Время присвоения тега',
      delay: 'С момента присвоения тега прошло',
      tags: 'Присвоенный тег',
    },
    [EUIConditionType.TAG_PRESENCE_CONDITION]: {
      title: 'Наличие тегов',
      include: 'Включить',
      exclude: 'Исключить',
    },
    [EUIActionType.ADD_SUBSCRIBER_TAG_ACTION]: 'Присвоить теги',
    [EUIActionType.DELETE_SUBSCRIBER_TAG_ACTION]: 'Удалить теги',
    [EUIActionType.CC_DIALOG_SWITCH_ACTION]: 'Перевести диалог в edna Chat Center',
    [EUIActionType.JIVO_DIALOG_SWITCH_ACTION]: 'Перевести диалог в Jivo',
    [EUIActionType.CALLBACK_DIALOG_SWITCH_ACTION]: 'Передать диалог через вебхук ',
    [EUIActionType.SEND_MESSAGE_ACTION]: 'Отправить шаблонное сообщение WhatsApp',
    [EUIActionType.CREATE_MESSAGE_ACTION]: {
      [EChannelType.WHATSAPP]: 'Отправить сообщение WhatsApp',
      [EChannelType.MAX_BOT]: 'Отправить сообщение в MAX Bot',
      [EChannelType.MAX]: 'Отправить сообщение в MAX',
    },
    [EUIActionType.PAUSE_ACTION]: 'Ожидание ответа',
  },
  triggerDescription: {
    [EUIActionType.CC_DIALOG_SWITCH_ACTION]: 'Диалог продолжится в <strong>Chat Center</strong>',
    [EUIActionType.JIVO_DIALOG_SWITCH_ACTION]: 'Диалог продолжится в Jivo',
    [EUIActionType.CALLBACK_DIALOG_SWITCH_ACTION]: 'Данные диалога будут отправлены через вебхук',
  },
  createMessageAction: {
    messageText: 'Текст сообщения',
    viewMessage: 'Просмотреть сообщение',
    whatsApp: {
      addButtons: 'Добавить кнопки',
      addButton: 'Добавить кнопку',
      buttonsLimit: 'До трех кнопок чата',
      buttonTitle: 'Кнопка чата',
      buttonText: 'Текст кнопки (до 20 символов)',
      buttonCode: 'Код кнопки, payload (до 128 символов)',
    },
    maxBot: {
      addToMessage: 'Добавить в сообщение',
      buttons: 'Кнопки',
      addButton: 'Добавить кнопку',
      buttonText: 'Текст кнопки (до 30 символов)',
      buttonPayload: 'Код кнопки, payload (до 250 символов)',
      buttonUrl: 'URL кнопки',
      attachment: 'Вложение',
      addAttachment: 'Добавить вложение',
    },
    maxBotAttachment: {
      [EContentType.DOCUMENT]: {
        title: 'Вставить файл',
        viewTitle: 'Прикрепленный файл',
        url: 'URL файла',
        option: 'Файл',
      },
      [EContentType.AUDIO]: {
        title: 'Вставить аудио',
        viewTitle: 'Прикрепленное аудио',
        url: 'URL аудио',
        option: 'Аудио',
      },
      [EContentType.VIDEO]: {
        title: 'Вставить видео',
        viewTitle: 'Прикрепленное видео',
        url: 'URL видео',
        option: 'Видео',
      },
      [EContentType.IMAGE]: {
        title: 'Вставить изображение',
        viewTitle: 'Прикрепленное изображение',
        url: 'URL изображения',
        option: 'Изображение',
      },
      [EContentType.LOCATION]: {
        title: 'Локация',
        viewTitle: 'Локация',
        longitude: 'Долгота (значение с точкой)',
        latitude: 'Широта (значение с точкой)',
        option: 'Локация',
      },
    },
    maxBotButtons: {
      [EMessageMatcherButtonTypes.CALLBACK]: 'Кнопка-ответ',
      [EMessageMatcherButtonTypes.TEXT]: 'Кнопка-текст',
      [EMessageMatcherButtonTypes.URL]: 'Кнопка-ссылка',
      [EMessageMatcherButtonTypes.LOCATION]: 'Кнопка-запрос локации',
      [EMessageMatcherButtonTypes.CONTACT]: 'Кнопка-запрос контакта',
    },
  },
  pauseAction: {
    createMessageHint:
      'Если следующим блоком будет действие «{{createMessageAction}}», помните, что ожидание не может быть более 23 часов 59 минут, так как нешаблонное сообщение можно отправить только в течение суток после последнего ответа получателя',
  },
  sendMessageAction: {
    template: 'Шаблон',
    ignoreSchedule: 'Игнорировать расписание сценария',
    messageMatcherId: 'Выберите шаблон сообщения, доступный для этого канала',
    hasAttachment: {
      [EContentType.IMAGE]:
        'В этом шаблоне есть заголовок-картинка. Загрузите файл с изображением или введите ссылку на него.',
      [EContentType.VIDEO]:
        'В этом шаблоне есть заголовок-видео. Загрузите файл с видео или введите ссылку на него.',
      [EContentType.DOCUMENT]:
        'В этом шаблоне есть заголовок-документ. Загрузите файл документа или введите ссылку на него.',
    },
    upload: 'Загрузить с компьютера',
    addLink: 'Вставить ссылку на файл',
    imageHint: 'Картинка (PNG или JPG до 5 МБ)',
    viewTemplate: 'Посмотреть шаблон',
    linkHint: {
      [EContentType.IMAGE]: 'Ссылка на картинку (до 200 символов)',
      [EContentType.VIDEO]: 'Ссылка на видео (до 200 символов)',
      [EContentType.DOCUMENT]: 'Ссылка на документ (до 200 символов)',
    },
    button: 'Кнопка',
    buttonName: 'Название',
    attachFile: 'Загрузить файл',
    buttonText: 'Текст кнопки',
    buttonCode: 'Код кнопки',
    buttonType: 'Тип кнопки',
    buttonTypeLabel: {
      [EMessageMatcherButtonTypes.PHONE]: 'Кнопка-звонок',
      [EMessageMatcherButtonTypes.URL]: 'Кнопка-ссылка',
      [EMessageMatcherButtonTypes.CHAT]: 'Кнопка чата',
      [ETemplateButtonOtpType.COPY]: 'Копировать код',
      [ETemplateButtonOtpType.AUTO]: 'Автоматическое заполнение',
    },
    staticUrl: 'Статическая часть ссылки',
    dynamicUrl: 'Динамическая часть ссылки',
    phoneNumber: 'Номер телефона',
    viewMessage: 'Просмотр сообщения',
    back: 'Назад',
    done: 'Готово',
    dynamicUrlRequired: 'Динамическая часть ссылки должна быть заполнена',
  },
  forms: {
    [EUIConditionType.BUTTON_PRESSED]: {
      whatsApp: {
        button: 'Кнопка',
        buttonLabel: 'Название кнопки (должно совпадать с шаблоном)',
        buttonId: 'Код кнопки, payload (должен совпадать с шаблоном)',
      },
      maxBot: {
        buttonText: 'Текст кнопки (до 30 символов)',
        buttonPayload: 'Код кнопки, payload (до 250 символов)',
      },
      addButton: 'Добавить кнопку',
    },
    [EUIConditionType.TAG_ASSIGN_TIMEOUT_CONDITION]: {
      delay: 'С момента присвоения тега получателю прошло',
      tags: 'Тег, присвоенный получателю',
    },
    [EUIConditionType.TAG_PRESENCE_CONDITION]: {
      tagsTree: 'Дерево тегов',
    },
    [EUIConditionType.ANSWER_TIMEOUT_CONDITION]: {
      title: 'Настроить блок условий',
      hint_1: [
        'Вместе с условием Нажатие кнопки в сообщении одновременно подключится условие Получено входящее сообщение.',
        'Так вы не потеряете получателей, которые в ответ на сообщение не нажмут на кнопку, но сами напишут вам.',
      ].join('<br/>'),
      hint_2:
        'Для тех, кто напишет входящее сообщение, из этого блока можно построить отдельную ветку сценария. ',
      hint_3: 'На выполнение любого из этих условий будет действовать одно время ожидания ответа.',
      answerTimeout: 'Время ожидания ответа:',
      save: 'Сохранить настройку',
    },
  },
  tag: 'Тег',
  systemWaiting: 'Ожидание в течение',
  condition: {
    yes: 'Да',
    no: 'Нет',
    notCompleted: 'Не выполнено',
  },
  contextMenu: {
    add: 'Добавить',
    deleteEdge: 'Удалить',
    deleteBlock: 'Удалить блок?',
    duplicateBlock: 'Дублировать блок',
    deleteTrigger: 'Удалить триггер?',
    duplicateTrigger: 'Дублировать триггер',
  },
  addButton: {
    [EFlowStepType.TRIGGER]: 'Выбрать условие',
    [EFlowStepType.CONDITION]: 'Выбрать условие',
    [EFlowStepType.ACTION]: 'Выбрать действие',
  },
  menu: {
    [EFlowStepType.ACTION]: 'Действие',
    [EFlowStepType.CONDITION]: 'Условие',
    settings: 'Настройки',
    [EMenuId.HELP]: 'Помощь',
    [EMenuId.NOTIFICATIONS]: 'Журнал событий',
    [EMenuId.SIGN_OUT]: 'Выход',
  },
  actionButton: {
    [EMenuButtonAction.START]: 'Запустить сценарий',
    [EMenuButtonAction.STOP]: 'Остановить сценарий',
    [EMenuButtonAction.SETTINGS]: 'Посмотреть настройки',
    [EMenuButtonAction.VIEW]: 'Посмотреть сценарий',
    [EMenuButtonAction.EDIT]: 'Редактировать сценарий',
    [EMenuButtonAction.COPY]: 'Копировать сценарий',
    [EMenuButtonAction.CANCEL]: 'Отменить запуск',
    [EMenuButtonAction.DELETE]: 'Удалить сценарий',
  },
  filters: {
    searchPlaceholder: 'Быстрый поиск по названию',
    flows: 'Сценариев',
  },
  th: {
    activatedAt: 'Дата запуска',
    channel: 'Канал',
    name: 'Название сценария',
    status: 'Статус',
    started: 'Запущено',
    startedHint: 'Количество получателей, для которых сработал стартовый блок сценария',
    inProgress: 'Выполняется',
    inProgressHint: 'Количество получателей, которые проходят сценарий',
    finished: 'Завершено',
    finishedHint: 'Количество получателей, для которых сценарий завершился успешно',
  },
  successModal: {
    [EMenuButtonAction.START]: {
      title: 'Сценарий успешно запущен!',
      message: 'Статистика переходов по шагам сценария будет отображаться в списке сценариев',
      confirmButton: 'Ок',
    },
  },
  modal: {
    [EMenuButtonAction.STOP]: {
      title: 'Остановить сценарий?',
      message: 'Сейчас в этом сценарии нет активных участников.',
      titleActive: 'Остановить сценарий с участниками?',
      messageActive:
        'В сценарий вовлечены <0>{{count}} участников.</0> Если вы остановите сейчас, участники не смогут его завершить.',
      confirmButton: 'Остановить',
    },
    [EMenuButtonAction.START]: {
      title: 'Запустить сценарий?',
      message: 'После запуска сценария его нельзя будет редактировать',
      confirmButton: 'Запустить',
    },
    [EMenuButtonAction.CANCEL]: {
      title: 'Отменить запуск сценария?',
      message:
        'После отмены запустить сценарий снова невозможно. Чтобы использовать этот сценарий повторно, его необходимо скопировать и сохранить с новым названием и расписанием.',
      confirmButton: 'Отменить запуск',
    },
    [EMenuButtonAction.DELETE]: {
      title: 'Удалить сценарий?',
      message:
        'Если вы удалите сценарий, все настройки, которые в нем содержатся, также будут удалены. Вы уверены?',
      confirmButton: 'Удалить',
    },
    [EMenuButtonAction.COPY]: {
      title: 'Копировать сценарий?',
      message:
        'Все блоки и связи этого сценария продублируются, но вам потребуется задать другое имя сценария и заново выставить расписание.',
      confirmButton: 'Копировать',
    },
    [EFlowStepType.TRIGGER]: {
      title: 'Выберите триггер, который запустит ваш сценарий',
    },
    [EFlowStepType.CONDITION]: {
      title: 'Выберите условие',
    },
    [EFlowStepType.ACTION]: {
      title: 'Выберите действие',
    },
    saveError: {
      title: 'Сохранение невозможно, в сценарии есть ошибки',
      message:
        'Мы не можем сохранить сценарий с ошибками внутри. Исправьте ошибки в блоках, подсвеченных красным, и сохраните сценарий еще раз',
      confirmButton: 'Исправить ошибки',
      cancelButton: 'Не сохранять',
    },
    saveCyclesError: {
      title: 'Внутри сценария есть замкнутый цикл',
      message:
        'В сценарии некоторые блоки зациклены между собой. Это может привести к тому, что получатели будут повторно проходить одни и те же этапы',
      confirmButton: 'Сохранить как есть',
      checkButton: 'Вернуться и проверить',
    },
    activateCyclesError: {
      title: 'Запустить сценарий с циклом внутри?',
      message:
        'В сценарии некоторые блоки зациклены между собой. Это может привести к тому, что получатели будут повторно проходить одни и те же этапы',
      confirmButton: 'Запустить как есть',
      checkButton: 'Вернуться и проверить',
    },
    confirmLeave: {
      title: 'Сохранить сценарий?',
      message:
        'Если выйти, не сохранив сценарий, все данные будут утеряны. Сценарий нужно будет создавать или редактировать заново',
      confirmButton: 'Выйти',
    },
  },
  notification: {
    activateSuccess: 'Сценарий успешно запущен',
    deactivateSuccess: 'Сценарий остановлен',
    saveSuccess: 'Сценарий успешно сохранен',
  },
  errors: {
    tagsRequired: 'Необходимо выбрать хотя бы один тег',
    [EUIStepError.MISSING_DATA]: 'Не введены настройки блока. Сценарий не может быть запущен',
    [EUIStepError.MISSING_TRIGGER_DATA]: 'Необходимо настроить условие в стартовом блоке',
    [EUIStepError.NOT_LAST_FLOW_STEP]: 'Условие не может быть последним блоком цепочки',
    [EUIStepError.MESSAGE_TIMEOUT_TOO_LONG]:
      'Действие невозможно: отправить нешаблонное сообщение можно только в течение 24ч с момента ответа получателя. Измените действие или время ожидания в предыдущем блоке',
    [EUIStepError.EMPTY_BUTTON_CONDITION]: 'Выберите значения кнопок',
    [EFlowErrorCodes.NON_TEMPLATE_MESSAGES_WITHOUT_IN_MESSAGE_FOUND]:
      'Действие невозможно: отправить нешаблонное сообщение можно только в течение 24ч с момента ответа получателя. Используйте условие "Получено входящее сообщение" или "Нажатие кнопки в сообщении" в этой ветке сценария',
    [EFlowErrorCodes.NON_TEMPLATE_MESSAGES_WITH_DAY_WINDOW_FOUND]:
      'Действие невозможно: отправить нешаблонное сообщение можно только в течение 24ч с момента ответа получателя. Измените действие или время ожидания в предыдущих блоках',
    [EFlowErrorCodes.HAS_ACTIVE_FLOW_WITH_IN_MESSAGE_FOR_SAME_SUBJECT]:
      'У вас уже активирован сценарий «{{name}}» с таким условием запуска. Чтобы активировать этот сценарий, остановите «{{name}}» или измените условие запуска.',
  },
  report: {
    title: 'Отчет по сценарию',
    description: 'Сформируйте и выгрузите отчет по взаимодействию получателей со сценарием',
    generate: 'Сформировать отчет',
    flowName: 'Название сценария',
    channel: 'Канал',
    download: 'Отчет по сценарию',
    pendingNotification: 'Формируем Отчет по сценарию {{name}}. <0>Посмотреть результат</0>',
    select: 'Выбрать',
  },
};
